var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { debugLog } from "./debugLog";
import { updateIntegrationParameter } from "./integrationParameter";
let parameters = undefined;
const getCustomLauncherParameters = (pathConfig) => __awaiter(void 0, void 0, void 0, function* () {
    const searchParams = new URLSearchParams(window.location.search);
    if (pathConfig.customlauncher === undefined) {
        return searchParams;
    }
    const response = yield fetch(pathConfig.customlauncher + "?" + searchParams.toString());
    const STATUS_OK = 200;
    if (response.status !== STATUS_OK) {
        debugLog(`customlauncher fetch failed: ${response.status}`);
        return searchParams;
    }
    try {
        const result = yield response.json();
        return new URLSearchParams(result.redirect_url);
    }
    catch (error) {
        debugLog("Invalid customlauncher response:", error);
        return searchParams;
    }
});
export const validateParameters = (pathConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    parameters = yield getCustomLauncherParameters(pathConfig);
    if (parameters.get("channel") !== "mobile") {
        (_a = document.getElementById("minimal-ui-treadmill")) === null || _a === void 0 ? void 0 : _a.remove();
        document.body.style.overflow = "hidden";
    }
    updateIntegrationParameter(parameters);
});
export const getParameter = (name) => {
    if (!parameters) {
        console.error("getParameter error: Attempting to get a parameter before validation");
        return null;
    }
    return parameters.get(name);
};
export const getGameRefParameter = () => {
    var _a;
    if (process.env.MODE === "development") {
        return (_a = getParameter("gameref")) !== null && _a !== void 0 ? _a : getParameter("gameid");
    }
    else {
        return getParameter("gameid");
    }
};
export const getLobbyIdParameter = () => {
    const provider = getParameter("provider");
    const lobbyId = getParameter("lobbyid");
    if (provider !== null && lobbyId !== null) {
        return `rlx.${provider}.${provider}.${lobbyId}`;
    }
    return null;
};
export const getValidatedParameters = () => {
    return new URLSearchParams(parameters);
};
